import { Product } from './product';
import { ChangedHistoryModel } from './changed-history';
import { PaymentHistoryModel } from './payment-history';
import { OrderComplainModel } from './order-complain';

export class Order {
    public id!: number;
    public createdDate!: string;
    public deposit!: number;
    public needDeposit!: number;
    public shopName!: string;
    public site!: string;
    public status!: number;
    public statusDetail!: any;
    public totalAmountVND!: number;
    public uId!: number;
    public imageOrigin!: string;
    public isChecked!: boolean;
    public shippingMethodID!: number;


    // Extands Detail
    public amountCNY!: number;
    public amountVND!: number;
    public buyerID!: number;
    public createdBy!: any;
    // public createdDate!: string;
    // public deposit!: number;
    public depostiDate!: string;
    public exchangeRate!: number;
    public feeBuy!: number;
    public feeBuyAmount!: number;
    public feeBuyDiscount!: number;
    public feeOther!: number;
    public feeShipCN!: number;
    public feeShipCNVND!: number;
    public feeWeight!: number;
    public feeWeightAmount!: number;
    public feeWeightDiscount!: number;
    // public id!: number;
    public isFeeShip!: boolean;
    public isFragileGoods!: boolean;
    public isHidden!: boolean;
    public isWeb!: boolean;
    public modifiedBy!: number;
    public modifiedDate!: string;
    public note!: string;
    public orderWeight!: number;
    public receivePlaceID!: number;
    public salerId!: number;
    public shopId!: number;
    // public shopName!: string;
    // public site!: string;
    // public status!: number;
    public storeCNID!: number;
    public storeVNID!: number;
    // public totalAmountVND!: number;
    public totalRealAmount!: number;
    public totalRealAmountCNY!: number;
    // public uId!: number;

    public products!: Product[];
    public changedHistories!: ChangedHistoryModel[];
    public paymentHistory!: PaymentHistoryModel[];
    public orderComplains!: OrderComplainModel[];
}
